var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"082b2aee82f9185876087a00aa19e231b5678307"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-react@privaposts"]={id:"082b2aee82f9185876087a00aa19e231b5678307"};
      